import { apiService } from 'services';

interface SignedVersionResponse {
  signature: string;
}

export const getJuniorContentSignature = (version: string) =>
  apiService.get<SignedVersionResponse>(`/content/junior/${version}`).then(({ signature }) => signature);
